module.exports = __webpack_public_path__ + "stockLibrary/simulator/007-beb904688a304262e9e7fa9479bf4454.png";